import flowApi from '../api/flowApi'

async function substepVerify(currentStepObj) {
    let currentSubstep = currentStepObj.steps[currentStepObj.current]
    if (currentSubstep.steps)  return await substepVerify(currentSubstep)
    return currentSubstep

}
async function currentStepVerify(userId, workspaceId){
    try {
        const res = await flowApi.get(`/owned-processes?userId=${userId}&workspaceId=${workspaceId}`)
        const flowData = res.data
        // console.log(`flowData: `, flowData)
        let currentStep = await substepVerify(flowData)
        const serviceName = currentStep.url.split(".")[0].split("-")[0].split("//")[1]
        // console.log("URL:", serviceName)
        if (serviceName !== "repense" && serviceName !== "localhost:8080/bet" && serviceName !== "localhost:8080/redirect") {
            const urlParams = new URLSearchParams(window.location.search);
            alert("Você não está nessa fase e será redirecionado", window.location.replace(`${currentStep.url}?uid=${userId}&workspaceId=${workspaceId}&token=${urlParams.get('token')}`))
            // console.log("redirectTo: ", `${currentStep.url}?uid=${userId}&workspaceId=${workspaceId}&token=${urlParams.get('token')}`)
            // alert("Você não está nessa fase e será redirecionado")
        } 
        localStorage.setItem(`currentStep`, JSON.stringify(currentStep))
        // console.log(`currentStep: `, currentStep)
        localStorage.setItem('flowData', JSON.stringify(flowData))
        return flowData
    } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.log(`Error to verify current step`, error)
        // return error
    }

}

export default currentStepVerify